
import { ENDPOINTS } from "utils/endpoints";
import { http } from "utils/http";


export const getJobActionList = (PageNumber: number, PageSize: number, ReferenceId: any ,orderByString) => http({
    url: ENDPOINTS.cartable.action.jobActionsList,
    method: 'get',
    params: {
        pageNumber: PageNumber,
        pageSize: PageSize,
        referenceId: ReferenceId,
        OrderByString:orderByString,
    }
}).then((res) => {
    
    return res.data
}).catch((err) => {
    return Promise.reject( err);
});


export const deleteAction = (actionId,referenceId) => http({
    url: ENDPOINTS.cartable.action.ActionOwner,
    method: 'delete',
    params: {
       actionId,
       referenceId
    }
}).then((res) => {
    
    return res.data
}).catch((err) => {
    return Promise.reject( err);
});